/* fo-carousel-hint.js — Bloque B (carrusel de colección)
   Pista de "hay más producto" en mobile:
   - Capa A (animación): auto-nudge UNA sola vez al entrar en viewport.
     Hace un scroll suave que asoma la 3a card y regresa al reposo (2 cards).
     Usa scrollLeft (no transform): es lo único que revela contenido real
     del scroll container, y con scroll-snap:proximity no se "pega".
   - Capa D (pista pasiva): el CSS pinta un fade en el borde derecho;
     este script lo apaga (.fo-hint-scrolled-end) cuando el usuario llega al final.
   Robustez: idempotente, 0..N tracks, matchMedia mobile, respeta
   prefers-reduced-motion, y re-aplica tras inyección de paginación. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 768.98px)';
  var REDUCED = '(prefers-reduced-motion: reduce)';
  var PEEK = 64; // px que asoma de la 3a card durante el nudge

  function setupFade(row, track) {
    if (row.dataset.foFade === '1') return;
    row.dataset.foFade = '1';
    var update = function () {
      // tolerancia de 2px por redondeos de subpíxel
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      // sin overflow real => no hay "más", oculta el fade
      var noOverflow = track.scrollWidth <= track.clientWidth + 2;
      row.classList.toggle('fo-hint-scrolled-end', atEnd || noOverflow);
    };
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function nudgeOnce(track) {
    if (track.dataset.foNudged === '1') return;
    track.dataset.foNudged = '1';
    if (window.matchMedia(REDUCED).matches) return; // sin movimiento
    var back = function () {
      try { track.scrollTo({ left: 0, behavior: 'smooth' }); }
      catch (e) { track.scrollLeft = 0; }
    };
    try {
      track.scrollTo({ left: PEEK, behavior: 'smooth' });
    } catch (e) {
      // navegadores sin scrollTo({behavior}): salto simple
      track.scrollLeft = PEEK;
    }
    // un solo setTimeout entre los dos smooth-scroll evita el bug de
    // encadenar dos animaciones de scroll en iOS Safari
    window.setTimeout(back, 650);
  }

  function initRow(row) {
    var track = row.querySelector('.fo-carousel-track');
    if (!track) return;

    setupFade(row, track); // el CSS limita el fade a mobile

    // El nudge solo aplica en mobile y solo si hay scroll real
    if (!window.matchMedia(MOBILE).matches) return;
    if (track.scrollWidth <= track.clientWidth + 4) return;
    if (track.dataset.foNudged === '1') return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            nudgeOnce(track);
            obs.unobserve(entries[i].target);
          }
        }
      }, { threshold: 0.4 });
      io.observe(row);
    } else {
      nudgeOnce(track);
    }
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var rows = scope.querySelectorAll('.fo-carousel-row');
    for (var i = 0; i < rows.length; i++) initRow(rows[i]);
  }

  // Re-aplica cuando la paginación inyecta nuevos .fo-carousel-row
  function watchInjections() {
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains('fo-carousel-row')) {
            initRow(node);
          } else if (node.querySelector) {
            init(node);
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    init(document);
    watchInjections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
